import { createFileRoute } from "@tanstack/react-router";

import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/client/components/shad/breadcrumb";

import { Badge } from "@/client/components/shad/badge";
import { SkopaDoc } from "@/client/docs/skopa/v1.0.0/SkopaDoc";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";

export const Route = createFileRoute("/(protected)/settings/skopa/docs")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Skopa</BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Documentation</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <SkopaDoc />
        </LayoutBody>
        <LayoutAside>
          <div className="h-full animate-in fade-in duration-500">
            <Card>
              <CardHeader>
                <CardTitle>
                  Skopa docs{" "}
                  <Badge className="bg-lime-50 text-lime-700 dark:bg-lime-950 dark:text-lime-300">
                    V-1.0.0
                  </Badge>
                </CardTitle>
                <CardDescription>
                  Descripting for the current status of Skopa
                </CardDescription>
              </CardHeader>
              <CardContent>Status content</CardContent>
            </Card>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
